import { partnerProductOrderItemMemoValuesState } from "@/atoms/item/partner-product-order-item-memo-values-state";
import { selectedPartnerProductOrderCartItemsState } from "@/atoms/item/selected-partner-product-order-cart-items-state";
import { previewState } from "@/atoms/quote/preview-state";
import { useRecoilValue } from "recoil";
import { ItemDetailLineDto } from "../../types/dto/item-detail-line-dto";
import { PartnerProductOrderCartItemCard } from "../card/PartnerProductOrderCartItemCard";

interface Props {
  checkedCartItems: ItemDetailLineDto[];
  handleCheckItem: (item: ItemDetailLineDto) => void;
}

// selectedPartnerProductOrderCartItemState atom에 요소가 있을 경우
export const PartnerProductOrderCartBody: React.FC<Props> = ({
  checkedCartItems,
  handleCheckItem,
}) => {
  const cartItems = useRecoilValue(selectedPartnerProductOrderCartItemsState);
  const preview = useRecoilValue(previewState);
  const memoValuesState = useRecoilValue(
    partnerProductOrderItemMemoValuesState
  );
  const isOpen = !!preview;

  return (
    <div
      className={`w-full flex flex-col overflow-y-auto ${
        isOpen ? "h-[563px]" : "h-[774px]"
      }`}
    >
      {cartItems.map((cartItem) => {
        const itemMemoValues =
          memoValuesState.find((memo) => memo.itemId === cartItem.childItem.id)
            ?.memoValues || [];

        return (
          <PartnerProductOrderCartItemCard
            key={cartItem.childItem.id}
            cartItem={cartItem}
            checkedCartItems={checkedCartItems}
            handleCheckItem={() => handleCheckItem(cartItem)}
            memoValues={itemMemoValues}
          />
        );
      })}
    </div>
  );
};
